<template>
  <div>
    <section-title
      content="Administrador de Accesorios"
      :has-line="true"
      containerClass="tag-badge-info-custom"
    />
    <span style="color:#727272">
      <i class="far fa-info-circle"></i>
      Los Accesorios añadidos estarán disponibles para seleccionar al momento de
      crear un equipo
    </span>

    <div class="row mt-4 px-lg-0 px-md-3">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <validation-observer tag="form" ref="observer">
          <div class="form-group">
            <validation-provider
              mode="eager"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <custom-input
                v-model="category"
                type="text"
                label="Añadir Nueva Categoría de Accesorios:"
                name="Categoría"
                :custom-error-msg="'Este campo es requerido'"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
        </validation-observer>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12 pt-2">
        <action-button
          :variant="'success mt-md-4 ' + (isMobile ? 'w-100' : '')"
          type="button"
          i="fas fa-file-plus"
          @click="addCategory"
        >
          A&ntilde;adir Categoría
        </action-button>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div
          :key="index"
          v-for="(item, index) in accessories"
          class="mt-4 "
          :has-toggle="false"
        >
          <custom-collapse
            :class="'mt-2 mx-1 ' + (!isMobile ? 'px-3' : '')"
            :id="'tab-' + index"
          >
            <custom-collapse-item
              class="rounded"
              :parentId="'tab-' + index"
              :title="item.name"
              :class="item.hasError ? 'border border-danger' : ''"
              :button-icon="item.sealed ? '' : 'far fa-times-circle color-red'"
              :expanded-icon="'fas fa-plus-circle color-black--3'"
              @actionButtonClick="removeItem(index)"
            >
              <validation-observer tag="form" :ref="'observer-' + index">
                <div class="row pt-4">
                  <div class="col-lg-3 col-md-6 col-sm-12 mb-2">
                    <validation-provider
                      mode="eager"
                      :rules="'required'"
                      v-slot="{ errors }"
                    >
                      <custom-input
                        v-model="item.detailModel.name"
                        type="text"
                        label="Nombre del Accesorio:"
                        :error="errors[0]"
                        :custom-error-msg="'Este campo es requerido'"
                      />
                    </validation-provider>
                  </div>
                  <div class="col-lg-3 col-md-6 col-sm-12 mb-2">
                    <validation-provider
                      mode="eager"
                      :rules="'required'"
                      v-slot="{ errors }"
                    >
                      <custom-input
                        v-model="item.detailModel.model"
                        type="text"
                        label="Modelo del Accesorio:"
                        :error="errors[0]"
                        :custom-error-msg="'Este campo es requerido'"
                      />
                    </validation-provider>
                  </div>
                  <div class="col-lg-3 col-md-6 col-sm-12 mb-2">
                    <validation-provider
                      mode="eager"
                      :custom-messages="{
                        required: 'El campo es requerido.',
                      }"
                      :rules="'required|greaterThanZero'"
                      v-slot="{ errors }"
                    >
                      <custom-input
                        v-model="item.detailModel.quantity"
                        :min="0"
                        type="number"
                        label="Cantidad Disponible:"
                        :error="errors[0]"
                      />
                    </validation-provider>
                  </div>
                  <div class="col-lg-3 col-md-6 col-sm-12 pt-md-2 mb-2">
                    <action-button
                      :variant="'success mt-md-4 ' + (isMobile ? 'w-100' : '')"
                      type="button"
                      i="fas fa-file-plus"
                      @click="addDetail(index)"
                    >
                      A&ntilde;adir
                    </action-button>
                  </div>
                </div>
              </validation-observer>
              <div class="row">
                <div v-if="item?.details?.length == 0" class="col-12">
                  <Empty />
                </div>
                <div class="col-12" v-else>
                  <div
                    :key="subIndex"
                    v-for="(detail, subIndex) in item.details"
                  >
                    <div class="p-3 my-3 bg-white rounded border-left-2">
                      <div class="row d-flex align-items-center px-3 ">
                        <div class="col-sm ">
                          <div class="bold font-16">{{ detail.name }}</div>
                          <div class="color-secondary-6 font-14">
                            {{ detail.model }}
                          </div>
                        </div>
                        <div class="col-sm ">
                          <div class="color-secondary-6 font-14">
                            Estatus:
                          </div>
                          <div class="bold">
                            <span class="d-flex align-items-center">
                              <div
                                class="status-indicator"
                                :style="{
                                  backgroundColor:
                                    detail.quantity - detail.assignedQuantity >
                                    0
                                      ? '#A3E5B3'
                                      : '#D5B89A',
                                }"
                              >
                                &nbsp;
                              </div>
                              <span class="text font-weight-bold">
                                {{
                                  detail.quantity - detail.assignedQuantity > 0
                                    ? 'Disponible'
                                    : 'No Disponible'
                                }}
                              </span>
                            </span>
                          </div>
                        </div>
                        <div class="col-sm ">
                          <div class="color-secondary-6 font-14">
                            Cantidad en Inventario:
                          </div>
                          <div>
                            {{ detail.quantity }}
                          </div>
                        </div>
                        <div class="col-sm ">
                          <div class="color-secondary-6 font-14">
                            Cantidad Disponible:
                          </div>
                          <div>
                            {{ detail.quantity - detail.assignedQuantity }}
                          </div>
                        </div>
                        <div class="col-sm ">
                          <div class="color-secondary-6 font-14">
                            Cantidad Asignada:
                          </div>
                          <div>
                            {{ detail.assignedQuantity }}
                          </div>
                        </div>
                        <div
                          v-if="
                            detail.id != null &&
                              detail.id != 0 &&
                              detail.id != undefined
                          "
                          class="col-md  d-flex justify-content-end"
                        >
                          <drop-down
                            :items="[
                              {
                                name: 'Ver ubicaciones',
                                icon: 'fas fa-info-circle text-green',
                                click: () => openLocations(index, subIndex),
                              },
                              {
                                name: 'Modificar Inventario',
                                icon: 'fas fa-edit text-green',
                                click: () => updateInventory(index, subIndex),
                              },
                            ]"
                            class="actions-dropdown pt-2"
                            normal-size
                            always-show-dropdown
                          />
                        </div>
                        <div
                          v-else-if="!detail.sealed"
                          class="col-md d-flex justify-content-end"
                        >
                          <action-button
                            :variant="
                              'outline-danger color-red ' +
                                (isMobile ? 'w-100 mt-4' : '')
                            "
                            class="text-white btn-outline"
                            i="fas fa-times-circle"
                            @click="removeSubItem(index, subIndex)"
                          >
                            {{ isMobile ? 'Remover' : '' }}
                          </action-button>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="detail.isLocationsOpened"
                      style="margin-top:-10px !important"
                      class="p-4 pb-2 bg-white rounded border-left-2"
                    >
                      <div class="row d-flex align-items-center px-4 ">
                        <div class="col-md-12 pt-0 px-4 ">
                          <span>
                            <i class="fas fa-info-circle text-orange mr-2"></i>
                            Ubicaciones de Accesorios
                          </span>
                          <accessory-locations :detail-id="detail.id" />
                        </div>
                        <div class="col-md-12 m-0 p-0 pt-0 mt-2 text-right">
                          <action-button
                            class="button-size"
                            id="modal-btn-cancelar"
                            variant="outline-danger btn-cancel"
                            type="button"
                            i="fas fa-times-circle"
                            @click="closeLocations(index, subIndex)"
                          >
                            Cerrar
                          </action-button>
                        </div>
                      </div>
                    </div>
                    <div
                      v-else-if="detail.showUpdateInventory"
                      style="margin-top:-10px !important"
                      class="p-4 pb-2 bg-white rounded border-left-2"
                    >
                      <div class="row d-flex align-items-center">
                        <div class="col-12 pt-0 px-4">
                          <accessory-update-inventory
                            :detail-id="detail.id"
                            @cancel="detail.showUpdateInventory = false"
                            @done="getAccessories"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </custom-collapse-item>
          </custom-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import CustomCollapse from '@/components/common/CustomCollapse';
import CustomCollapseItem from '@/components/common/CustomCollapseItem';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Empty from '@/components/common/Empty.vue';
import mixAlert from '@/mixins/alert.mixin';
import service from '@/services/api/inventorycatalog.api';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import DropDown from 'dropdown';

import AccessoryLocations from './components/AccessoryLocations.vue';
import AccessoryUpdateInventory from './components/AccessoryUpdateInventory.vue';

export default {
  name: 'Accessory',
  components: {
    SectionTitle,
    CustomInput,
    ActionButton,
    ValidationObserver,
    ValidationProvider,
    CustomCollapse,
    CustomCollapseItem,
    Empty,
    DropDown,
    AccessoryLocations,
    AccessoryUpdateInventory,
  },
  mixins: [mixAlert],
  data: () => ({
    category: null,
    accessories: [],
    value: [],
  }),
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    inventoryCatalogId() {
      return Number(this.$route.params.id);
    },
  },
  methods: {
    closeLocations(index, subIndex) {
      this.accessories[index].details[subIndex].isLocationsOpened = false;
    },
    openLocations(index, subIndex) {
      const item = this.accessories[index].details[subIndex];
      item.showUpdateInventory = false;
      item.isLocationsOpened = true;
    },
    updateInventory(index, subIndex) {
      const item = this.accessories[index].details[subIndex];
      item.isLocationsOpened = false;
      item.showUpdateInventory = true;
    },
    async addCategory() {
      const valid = await this.$refs['observer'].validate();
      if (valid) {
        this.accessories.push({
          name: this.category,
          catalogId: this.inventoryCatalogId,
          details: [],
          detailModel: {
            name: null,
            model: null,
            quantity: null,
          },
        });
        this.inputHandler();
        this.category = null;
        await this.$refs['observer'].reset();
      }
    },
    clearDetailModel(index) {
      this.accessories[index].detailModel.name = null;
      this.accessories[index].detailModel.quantity = null;
      this.accessories[index].detailModel.model = null;
    },
    async addDetail(index) {
      const valid = await this.$refs['observer-' + index][0].validate();
      if (valid) {
        const accessory = this.accessories[index];
        this.accessories[index].details.push({
          accessoryId: accessory.id,
          name: accessory.detailModel.name,
          quantity: accessory.detailModel.quantity,
          availableQuantity: accessory.detailModel.quantity,
          model: accessory.detailModel.model,
          assignedQuantity: 0,
        });
        this.clearDetailModel(index);
        this.inputHandler();
        await this.$refs['observer-' + index][0].reset();
      }
    },
    async removeItem(index) {
      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea remover la categoría <strong>${this.accessories[index].name}</strong>?`,
        'Sí',
        'No'
      );
      if (!isConfirmed) {
        return;
      }
      this.accessories.splice(index, 1);
      this.inputHandler();
    },
    async removeSubItem(index, subIndex) {
      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea remover el accesorio <strong>${this.accessories[index].details[subIndex].name}</strong>?`,
        'Sí',
        'No'
      );
      if (!isConfirmed) {
        return;
      }
      this.accessories[index].details.splice(subIndex, 1);
      this.inputHandler();
    },
    inputHandler() {
      this.value = this.accessories.map((x) => {
        return {
          accessoryId: x.accessoryId,
          id: x.id,
          name: x.name,
          details: x.details,
          catalogId: x.catalogId,
        };
      });
    },
    validate() {
      const invalid =
        this.accessories.length == 0 ||
        this.accessories.some((x) => x.details.length == 0);

      return {
        valid: !invalid,
        message: invalid ? 'Completar Tab de Accesorios' : '',
      };
    },
    async save() {
      try {
        let exit = false;
        this.accessories.forEach((element, index) => {
          if (element.details.length == 0) {
            this.ShowToast(
              'Alerta',
              'Debe al menos agregar un accesorio a la categoría.',
              'error'
            );
            exit = true;
            this.accessories[index].hasError = true;
          } else {
            this.accessories[index].hasError = false;
          }
        });
        if (!exit) {
          await service.addAccessories(this.inventoryCatalogId, this.value);
          this.ShowToast(
            'Éxito',
            'Información ha sido guardada exitosamente.',
            'success'
          );
          await this.getAccessories();
        }
        this.$forceUpdate();
      } catch (error) {
        this.ShowToast('Alerta', error?.response?.data.message, 'error');
      }
    },
    async getAccessories() {
      try {
        const { data } = await service.getAccessories(this.inventoryCatalogId);
        this.accessories = data.map((x) => ({
          ...x,
          hasError: false,
          details: x.details.map((z) => ({
            ...z,
            isLocationsOpened: false,
            showUpdateInventory: false,
          })),
          detailModel: {
            name: null,
            model: null,
            quantity: null,
          },
        }));
      } catch (error) {
        this.ShowToast('Alerta', error?.response?.data.message, 'error');
      }
      this.inputHandler();
    },
  },
  mounted() {
    this.getAccessories();
  },
};
</script>

<style scoped>
.status-indicator {
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  margin-right: 5px;
}
</style>
